import config from '../../../config';

const baseUrl = `${config.apiUrl()}/PaymentPartners`;

export default {
  getBaseUrl: () => `${baseUrl}`,
  baseContentUrl: (): string => `${baseUrl}/Content`,
  fineOutstandingUrl: (): string => `${baseUrl}/Total-Fines-Outstanding`,
};
